import 'es6-object-assign/auto'
import Vue from 'vue'
import MemberRegistration from './MemberRegistration.vue'
import '../../common/GlobalVueConfig';


new Vue({
  render: h => h(MemberRegistration)
}).$mount('#member-registration-app');
